



















import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
import MainTemplate from '@/components/MainTemplate.vue'
import { loadFromLocal } from '@/utils/local'
import { myOS } from '@/utils/urlUtils'
import { paperDoc, paperDocS2 } from './models/api'

@Component({
  components: { MainTemplate }
})
export default class DownloadFinsh extends Vue {
  public imgs = ['.jpg', '.jpeg', '.bmp', 'gif', 'png', 'pdf']
  public get url() {
    let str = this.$route.query.url
    return str
  }
  public get subjectId() {
    return this.$route.query.subject_id
  }
  public get site() {
    return this.$route.query.site
  }
  public get paperId() {
    return this.$route.query.paper_id
  }
  public get da() {
    return this.$route.query.da
  }
  public get df() {
    return this.$route.query.df
  }
  public get dm() {
    return this.$route.query.dm
  }
  public get userName() {
    return loadFromLocal('net_username')
  }
  public get isOSX() {
    if (myOS() === 'osx') {
      return true
    } else {
      return false
    }
  }

  public mounted() {
    if (!this.userName) {
      location.href = '/search'
      return
    }
    if (this.url) {
      this.downloadFile(this.url)
    }
    // this.downloadOtherFile()
  }
  // //判断是否为Trident内核浏览器(IE等)函数
  // public browserIsIe() {
  //   if (!!window.ActiveXObject || 'ActiveXObject' in window) {
  //     return true
  //   } else {
  //     return false
  //   }
  // }
  // public createIframe() {
  //   // 创建iframe并赋值的函数,传入参数为图片的src属性值.
  //   // 如果隐藏的iframe不存在则创建
  //   if ($('#IframeReportImg').length === 0) {
  //     $(
  //       '<iframe style="display:none;" id="IframeReportImg" name="IframeReportImg" onload="downloadImg();" width="0" height="0" src="about:blank"></iframe>'
  //     ).appendTo('body')
  //   }
  //   // iframe的src属性如不指向图片地址,则手动修改,加载图片
  //   if ($('#IframeReportImg').attr('src') !== this.url) {
  //     $('#IframeReportImg').attr('src', this.url)
  //   } else {
  //     // 如指向图片地址,直接调用下载方法
  //     this.downloadImg()
  //   }
  // }
  // public downloadImg() {
  //   // 下载图片的函数
  //   // iframe的src属性不为空,调用execCommand(),保存图片
  //   if ($('#IframeReportImg').src != 'about:blank') {
  //     window.frames['IframeReportImg'].document.execCommand('SaveAs')
  //   }
  // }
  // public downloadOtherFile() {
  //   if (this.browserIsIe()) {
  //     this.createIframe(this.url)
  //   }
  // }
  public reDownload() {
    if (this.url) {
      this.downloadFile(this.url + '')
    }
    if (this.site == '2') {
      this.getPaperDoc()
    }
  }
  public async getPaperDoc() {
    let req = {
      subject_id: this.subjectId,
      paper_id: this.paperId,
      site: this.site,
      da: this.da,
      df: this.df,
      dm: this.dm
    }
    let res: any = null
    let data = await paperDoc(req)
    if (this.site == '2') {
      res = await paperDocS2({
        site: ~~this.site,
        doc_src: data.data.doc_src
      })
    }
    if (res && res.data && res.data.doc_src) {
      location.href = res.data.doc_src
    } else {
      location.href = data.data.doc_src
    }
  }
  public downloadFile(url) {
    // try {
    //   let elemIF = document.createElement('iframe')
    //   elemIF.src = url
    //   elemIF.style.display = 'none'
    //   document.body.appendChild(elemIF)
    // } catch (e) {
    //   console.log(e)
    // }
    if (
      this.imgs.some((itm) => {
        return url.toLowerCase().indexOf(itm)
      })
    ) {
      let alink = document.createElement('a')
      alink.href = url
      alink.download = 'url' //图片名
      alink.click()
    } else {
      try {
        let elemIF = document.createElement('iframe')
        elemIF.src = url
        elemIF.style.display = 'none'
        document.body.appendChild(elemIF)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
